// extracted by mini-css-extract-plugin
module.exports = {"bondhushava-footer":"bondhushavaFooter-m__bondhushava-footer__3yiLD","address":"bondhushavaFooter-m__address__4YiqJ","social-links":"bondhushavaFooter-m__social-links__10Q-F"};